'use client'

import clsx from 'clsx'

interface TaxRowProps {
    label: string
    value?: string
    note?: string
}

export default function TaxRow({
    label,
    value,
    note,
}: TaxRowProps) {
    return (
        <div className="flex items-center justify-between border-b border-[#f5f5f5] py-2.5 last:border-b-0">
            <span className="text-[14px] font-medium text-[#404040]">{label}</span>

            {/* If note is provided, show "Xem chi tiết" with tooltip */}
            {note ? (
                <div className="group relative">
                    <span className="cursor-help text-[15px] font-bold text-[#1E40AF] underline decoration-dotted underline-offset-2">
                        Xem chi tiết
                    </span>
                    <div className="pointer-events-none absolute bottom-full right-0 mb-2 hidden w-64 rounded-lg border border-[#DBEAFE] bg-white p-3 text-xs text-[#404040] shadow-lg group-hover:block z-10">
                        <div className="mb-1 font-semibold text-[#1E40AF]">Ghi chú:</div>
                        <div className="whitespace-pre-wrap">{note}</div>
                        {/* Arrow */}
                        <div className="absolute -bottom-1 right-4 h-2 w-2 rotate-45 border-b border-r border-[#DBEAFE] bg-white" />
                    </div>
                </div>
            ) : (
                /* Otherwise show the value with optional styling */
                <span
                    className={clsx(
                        'text-[14px] font-semibold',
                        value === 'Không áp dụng' && 'text-(--neutral-400)'
                    )}
                >
                    {value}
                </span>
            )}
        </div>
    )
}
